import { ApplicationStep } from '@payright/types-bnpl-checkout-api';
import { RoutePath } from '../routes';

// NOTE: The ordering of the steps is important as it dictates the order of the pages
export const ApplicationSteps: ApplicationStep[] = [
  'Plan Purpose',
  'Customer Details',
  'Household Expenses',
  'Bank Statements',
  'Customer Consent',
  'Plan Contract',
  'Payment',
  'Plan Result',
];

export const isAllowedAtStep = (step: ApplicationStep, planStep: ApplicationStep): boolean => {
  const stepIndex = ApplicationSteps.findIndex((s) => s === step);
  const planStepIndex = ApplicationSteps.findIndex((s) => s === planStep);

  if (stepIndex === -1 || planStepIndex === -1) return false;

  // User can only access steps up to their current plan step
  return stepIndex <= planStepIndex;
};

export const getStepRoute = (step: ApplicationStep): RoutePath | undefined => {
  switch (step) {
    case 'Plan Purpose':
      return '/payment-plan/plan-purpose';
    case 'Customer Details':
      return '/payment-plan/customer-details';
    case 'Household Expenses':
      return '/payment-plan/household-expenses';
    case 'Bank Statements':
      return '/payment-plan/bank-statements';
    case 'Customer Consent':
      return '/payment-plan/summary'; // TODO: Change to customer-consent
    case 'Plan Contract':
      return '/payment-plan/contract';
    case 'Payment':
      return '/payment-plan/payment';
    case 'Plan Result':
      return '/payment-plan/plan-result';
    default:
      return undefined;
  }
};
